import { addDatabaseConfigInstanceAction } from 'actions/applicationActions'
import { getBasicAuthCredentials } from 'api/authentication'
import { put, call } from 'redux-saga/effects'
import axios from 'axios'
import axiosRetry from 'axios-retry'

export default function * configDatabase() {
  const credentials = yield call(getBasicAuthCredentials)
  const database = axios.create({
    baseURL: `${CLOUDANT_URL}/${credentials.name}`,
    auth: {
      username: credentials.name,
      password: credentials.password
    }
  })
  axiosRetry(database, {
    retries: 0,
    retryCondition: axiosRetry.isRetryableError,
    retryDelay: axiosRetry.exponentialDelay
  })

  yield put(addDatabaseConfigInstanceAction(database))
  return database
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/configDatabase.js